import { render, staticRenderFns } from "./searchTips.vue?vue&type=template&id=873049aa&"
import script from "./searchTips.vue?vue&type=script&lang=js&"
export * from "./searchTips.vue?vue&type=script&lang=js&"
import style0 from "./searchTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports